(function(){
  var last=null;
  function box(){ return document.querySelector('[data-wlb]'); }
  function srcFor(btn){
    var s=btn.getAttribute('data-wzoom');
    if(s) return s;
    var img=btn.querySelector('img');
    if(!img) return '';
    var cur=img.currentSrc||img.src;
    return /[?&]width=\d+/.test(cur) ? cur.replace(/([?&])width=\d+/, '$1width=1600') : cur;
  }
  function open(btn){
    var lb=box(); if(!lb) return;
    var img=lb.querySelector('[data-wlb-img]');
    img.src=srcFor(btn);
    img.alt=btn.getAttribute('data-walt')|| (btn.querySelector('img')&&btn.querySelector('img').alt) ||'';
    lb.hidden=false; last=btn;
    document.body.style.overflow='hidden';
    var x=lb.querySelector('[data-wlb-close]'); if(x) x.focus();
  }
  function close(){
    var lb=box(); if(!lb||lb.hidden) return;
    lb.hidden=true; lb.querySelector('[data-wlb-img]').src='';
    document.body.style.overflow='';
    if(last){ last.focus(); last=null; }
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-wzoom],[data-zoom-main]');
    if(b){ e.preventDefault(); open(b); return; }
    if(e.target.closest('[data-wlb-close]')){ close(); return; }
    var lb=e.target.closest('[data-wlb]');
    if(lb && !e.target.closest('[data-wlb-img]')) close();
  });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') close(); });
})();
